<template>
    <div class="row">

        <div class="col-md-4">
            <select2
                    :options="comparatorList"
                    :displayLabel="false"
                    size="sm"
                    :model.sync="comparatorLocal"
                    :clearable="false"
                    :disabled="isDisabled"
                    label="i18n"
            />
        </div>

        <div class="col-md-8">
            <input-field
                    :model.sync="inputValueLocal"
                    size="sm"
                    class="my-auto"
                    :disabled="isInputValueDisabled"
            />
        </div>

    </div>
</template>

<script>
import { ref, computed, watch } from '@vue/composition-api'
import { capitalize } from '../../../../utils/filter'

import select2 from '../../../input/Select2.vue'
import InputField from '../../../input/Input.vue'
import i18n from '../../../../libs/i18n'

export default {
  components: {
    select2,
    InputField
  },
  props: {
    field: {
      type: Object,
      default: () => {}
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  setup (props, { emit }) {
    // ------------------------------------------------
    // Data
    // ------------------------------------------------
    const comparatorLocal = ref({
      value: props.field.filter.comparator,
      i18n: capitalize(i18n.t(props.field.filter.comparator))
    })

    const comparatorList = ref([
      {
        value: 'equal',
        i18n: capitalize(i18n.t('equal'))
      },
      {
        value: 'not_equal',
        i18n: capitalize(i18n.t('not_equal'))
      },
      {
        value: 'greater_than',
        i18n: capitalize(i18n.t('greater_than'))
      },
      {
        value: 'greater_than_or_equal',
        i18n: capitalize(i18n.t('greater_than_or_equal'))
      },
      {
        value: 'less_than',
        i18n: capitalize(i18n.t('less_than'))
      },
      {
        value: 'less_than_or_equal',
        i18n: capitalize(i18n.t('less_than_or_equal'))
      },
      {
        value: 'is_empty',
        i18n: capitalize(i18n.t('is_empty'))
      },
      {
        value: 'is_not_empty',
        i18n: capitalize(i18n.t('is_not_empty'))
      },
    ])

    const inputValueLocal = ref(props.field.filter.value)

    // ------------------------------------------------
    // Computed
    // ------------------------------------------------
    const isInputValueDisabled = computed(() => {
      if (
        props.isDisabled ||
        (
          comparatorLocal.value != null &&
          (
            comparatorLocal.value.value == 'is_empty' ||
            comparatorLocal.value.value == 'is_not_empty'
          )
        )
      ) {
        return true
      } else {
        return false
      }
    })

    // ------------------------------------------------
    // Watch
    // ------------------------------------------------
    watch(comparatorLocal, val => {
      if (
        val != null &&
        (
          val.value == 'is_empty' ||
          val.value == 'is_not_empty'
        )) {
        inputValueLocal.value = null
      }

      parentUpdate()
    })

    let delayTimer
    watch(inputValueLocal, val => {
      clearTimeout(delayTimer);
      delayTimer = setTimeout(() => {
        parentUpdate()
      }, 500);
    })

    // ------------------------------------------------
    // Methods
    // ------------------------------------------------
    const parentUpdate = () => {
      if (isInputValueDisabled.value) {
        let fieldLocal = props.field
        fieldLocal.filter.comparator = comparatorLocal.value.value
        fieldLocal.filter.field = props.field.name
        fieldLocal.filter.value = null

        console.log(fieldLocal)
        emit('updateFieldFilter', fieldLocal)
      } else if (
        comparatorLocal.value != null &&
        inputValueLocal.value != null &&
        inputValueLocal.value != ''
      ) {
        let fieldLocal = JSON.parse(JSON.stringify(props.field))
        fieldLocal.filter.comparator = comparatorLocal.value.value
          fieldLocal.filter.field = props.field.entity ? props.field.entity : props.field.name
          fieldLocal.filter.value = inputValueLocal.value

        // console.log(fieldLocal)

        emit('updateFieldFilter', fieldLocal)
      }
    }

    // ------------------------------------------------
    // Mounted
    // ------------------------------------------------

    // ------------------------------------------------
    // Setup
    // ------------------------------------------------
    return {
      // Components
      capitalize,

      // Data
      comparatorLocal,
      comparatorList,
      inputValueLocal,

      // Computed
      isInputValueDisabled,

      // Methods
    }
  },
  data () {
    return {}
  },
  computed: {},
  watch: {},
  methods: {},
  mounted () {
  },
  created () {
  }
}
</script>

<style lang="scss">

</style>